import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Ad Copy',
	'Social Media Copy',
	'Business Names',
	'Translation',
	'Research',
	'Articles & Blog Posts'
]

const WritingAndTranslation = () => {
	return (
		<>
			<GeneralTitle>Writing & Translation</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>Have a way with words</Title>
					<Paragraph>
						Get Ad copy, Social Media Copy, Articles & Blog Posts,
						Research and translation at ease with Webackit
						Solutions.
					</Paragraph>
					<Paragraph>
						We use automation to quickly gather as many pieces of
						information as possible, structure them by quality,
						ranking possibilities, and the number of
						likes/shares/comments. We build our strategy and content
						from there.
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-writing-translation.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-unlock-your-startup-potential.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default WritingAndTranslation
